import styled from "styled-components";

export const Toolbar = styled.div` 
  .toolbar {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    background-color: #FFFFFF78;
    border-radius: 20px;
    margin: 0 20px 10px;
    &__separator {
      height: 9px;
      border-right: 1px solid rgba(62, 62, 91, 0.4);
      margin: 0 10px;
    }
    &__left {
      display: flex;
      align-items: center;
    }
    &__center {
      display: flex;
      align-items: center;
      margin: 0 40px;
      width: 100%;
    }
    &__right {
      display: flex;
      align-items: center;
    }
    &__button {
      border-radius: 13px;
      border: 2px solid #FFFFFF;
      background-color: #FFFFFF80;
      color: #3E3E5B;
      height: 36px;
      min-width: 36px;
      justify-content: center;
      display: flex;
      align-items: center;
      &-text {
        margin: 0 10px;
      }
      &-icon {
        font-family: Nunito Sans;
        font-size: 14px;
        &--plus {
          font-size: 14px;
        }	
        &--clock {
          font-size: 23px;
        }
      }
    }
    .patient-selection {
      display: flex;
      align-items: center;
      &__img {
        margin-right: 10px;
      }
      .patient-img {
        min-height: 40px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        box-shadow: 0px 2px 6px #0000001A;
        font-size: 8px;
        vertical-align: middle;
        border: 2px solid #FFFFFF
      }
    }
    .item-selected {
      cursor: pointer;
      &__label {
        display: flex;
        align-items: center;
        font-family: Nunito Sans;
        font-size: 13px;
        color: #3E3E5B;
      }
      &__icon {
        font-size: 11px;
        color: #3E3DA3;
        margin-left: 5px;
      }
      &__name {
        color: #3E3E5B;
        font-family: Nunito Sans Bold;
        font-size: 14px;
        inline-size: max-content;
      }
    }
  }
  .searcher-container {
    display: flex;
    justify-content: center;
    width: 100%;
    .searcher-content {
      width: 100%;
      padding: 10px;
      border-radius: 74px;
      background: #FFFFFF;
      box-sizing: border-box;
      cursor: text;
      z-index: 100;
      display: flex;
      align-items: center;
      &__icon {
        color: #36369B;
        font-size: 21px;
      }
    }
    .searcher-input {
      display: flex;
      justify-content: space-between;
      height: 100%;
      &__input {
        margin: 0 5px;
        border: none;
        outline: none;
        width: 100%;
        background-color: transparent;
        font-family: "Nunito Sans";	
        font-size: 19px;
        color: #36369B;
        height: 100%;
        ::placeholder {
          color: #707582;
        }
      }
      &__icon {
        color: #36369B;
        font-size: 28px;
      }
    }
  }
`

export const PopUpItemSelected = styled.div`
  box-shadow: 0px 0px 63.9px 36px #FFFFFF70 inset;
  backdrop-filter: blur(60px);
  box-shadow: 0px 0px 19.4px 15px #50507F1A;
  border: 2px solid #FFFFFF;
  background-color: #EFEFF6F2;
  border-radius: 20px;
  padding: 20px;
  .title {
    font-family: Nunito Sans Light;
    font-size: 25px;
    color: #1F1F52;
    margin-bottom: 10px;
    white-space: nowrap;
  }
  .separator {
    width: 100%;
    border-bottom: 2px solid #FFFFFF;
    margin-bottom: 20px;
  }
  .item {
    height: 50px;
    width: 100%;
    align-content: center;
    cursor: pointer;
    font-size: 20px;
    &__title {
      &--selected {
        font-family: Nunito Sans Bold;
      }
    }
    &__selected {
      font-family: Nunito Sans;
      font-size: 12px;
      color: #1F1F52;
    }
  }
`